import React, { useEffect, ReactNode } from 'react';
import ThemeMui from '@digital-hig/theme-mui';
import Button from '@digital-hig/button';
import ErrorIcon from '@digital-hig/icon/lib/build/display-icons/error';
import Typography from '@digital-hig/typography';
import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';
import useAnalytics from '../../hooks/useAnalytics';
import ProfileMFEViewSelector from '../ProfileMFEViewSelector';
import { useAdpAnalytics } from '@profile-ui-mono/utilities/context/AdpAnalyticsProvider';
import { adpAnalyticsEvents } from '@profile-ui-mono/utilities/constants/adpAnalyticsEvents';

type ErrorComponentProps = {
  appId?: string;
  header?: string | ReactNode;
  errorTitle?: string;
  errorMessage?: string;
  buttonText?: string;
  isModalOpen?: boolean;
  variant?: string;
  browserView?: undefined | 'fullpage';
  onClose?: () => void;
};

function ErrorComponent({
  header,
  errorTitle = 'Something went wrong',
  errorMessage = 'An unexpected error occurred. Please try again later.',
  buttonText = 'Close',
  isModalOpen = true,
  variant = 'modal',
  browserView,
  appId,
  onClose,
}: ErrorComponentProps) {
  const { logEvent } = useAnalytics({ appId });
  const adp = useAdpAnalytics();

  useEffect(() => {
    logEvent(`${errorTitle}, ${errorMessage}`);
    adp?.track(adpAnalyticsEvents.METRICS_SETTING, {
      component_id: 'mfe_error-component',
      component_name: 'mfe_error-component',
    });
  }, []);

  return (
    <ThemeMui themePrefix="profile-error">
      <ProfileMFEViewSelector
        browserView={browserView}
        isModalOpen={isModalOpen}
        onClose={onClose}
        isError
        variant={variant}
        header={header}
        footer={
          <Button data-adp-click="true" onClick={onClose} fullWidth variant="contained" data-testid="mfe_close-button">
            {buttonText}
          </Button>
        }
      >
        <Box pt={7}>
          <SvgIcon fontSize="large" sx={{ paddingBottom: '0 !important' }}>
            <ErrorIcon />
          </SvgIcon>
          <Box mt={4}>
            <Typography variant="headline-smaller">{errorTitle}</Typography>
          </Box>
          <Box mt={2} mb={8}>
            <Typography variant="body-copy-medium">{errorMessage}</Typography>
          </Box>
        </Box>
      </ProfileMFEViewSelector>
    </ThemeMui>
  );
}

export default ErrorComponent;
